<script>
  import { toast, hideToast } from '../lib/stores/toast.js';
</script>

{#if toast.visible}
  <div class="toast toast-{toast.kind}" onclick={hideToast}>
    <span class="toast-icon">
      {#if toast.kind === 'success'}✓{:else if toast.kind === 'error'}!{:else}i{/if}
    </span>
    <span class="toast-msg">{toast.message}</span>
    <button class="toast-x" onclick={hideToast} aria-label="Dismiss">×</button>
  </div>
{/if}

<style>
  .toast {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(180deg, rgba(20,18,22,0.96), rgba(12,11,14,0.96));
    border: 1px solid rgba(255,255,255,0.12);
    color: #f0efe9;
    padding: 12px 18px 12px 14px;
    border-radius: 12px;
    font-size: 13px;
    z-index: 2000;
    box-shadow: 0 12px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06);
    animation: toastIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    max-width: 90vw;
  }
  @keyframes toastIn {
    from { opacity: 0; transform: translate(-50%, 12px); }
    to   { opacity: 1; transform: translate(-50%, 0); }
  }
  .toast-success { border-color: rgba(124,217,146,0.35); }
  .toast-success .toast-icon { background: rgba(124,217,146,0.18); color: #7cd992; }
  .toast-error { border-color: rgba(212,100,100,0.4); }
  .toast-error .toast-icon { background: rgba(212,100,100,0.18); color: #d48484; }
  .toast-info { border-color: rgba(122,184,255,0.35); }
  .toast-info .toast-icon { background: rgba(122,184,255,0.18); color: #7AB8FF; }
  .toast-icon {
    width: 22px; height: 22px;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
  }
  .toast-msg { line-height: 1.45; }
  .toast-x {
    background: transparent;
    border: none;
    color: #888;
    font-size: 18px;
    line-height: 1;
    padding: 0 4px;
    cursor: pointer;
    margin-left: 6px;
  }
  .toast-x:hover { color: #fff; }
</style>
